import _extends from '@babel/runtime/helpers/extends';
import React__default, { useState, useEffect } from 'react';
import { S as Shroud, H as Header, C as CloseButton, a as CloseButtonIcon, b as Content } from './SecondaryView.styles-DTtygCEQ.js';
import { V as View } from './View-ERGmpE5j.js';
import { I as InlinePortalProvider } from '../Portal/InlinePortalProvider-CZof7mQs.js';
import { u as useTaktId } from '../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { u as useDetectVirtualKeyboard } from '../LocalModules/storm-ui-utils/dist/esm/virtualKeyboard/useDetectVirtualKeyboard-XkMJ_5y1-XkMJ_5y1.js';
import { P as PreventScroll } from '../LocalModules/storm-ui-utils/dist/esm/PreventScroll-xF1A993L-CbrV58O0.js';
import { B as angleInlineStart } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-sBnDaVj5-23EprBeB.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';

function createSetSizeToVisualViewport(containerRef) {
  return function setSizeToVisualViewport() {
    if (containerRef.current instanceof HTMLDivElement && window.visualViewport) {
      // To fix issue caused by virtual keyboard
      const {
        height,
        width
      } = window.visualViewport;
      const {
        style
      } = containerRef.current;
      style.height = `${height}px`;
      style.width = `${width}px`;
    }
  };
}
const Overlay = ({
  fadeDuration,
  transitionState,
  handleKeyDown,
  handleKeyUp,
  containerRef,
  onClose,
  closeButtonRef,
  closeButtonLabel,
  closeButtonProps,
  padding,
  children,
  ...rest
}) => {
  const {
    getDataTaktAttributes: getCloseButtonDataTaktAttributes
  } = useTaktId({
    taktId: closeButtonProps === null || closeButtonProps === void 0 ? void 0 : closeButtonProps.taktId,
    fallbackId: createStormTaktId('close-button')
  });
  // bool to track keyboard open state locally.
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
  const [isVirtualKeyboardOpen] = useDetectVirtualKeyboard();
  useEffect(() => {
    if (typeof window !== 'undefined' && 'visualViewport' in window && window.visualViewport) {
      const {
        visualViewport
      } = window;
      const setSizeToVisualViewport = createSetSizeToVisualViewport(containerRef);

      // if the keyboard is opened, set the local state to open
      if (isVirtualKeyboardOpen) {
        setIsKeyboardOpen(true);
      }

      // this code block is executed if the keyboard is either open,
      // or was open and is now closed (tracked by the local isKeyboardOpen state)
      if (isVirtualKeyboardOpen || isKeyboardOpen) {
        setIsKeyboardOpen(isVirtualKeyboardOpen);
        visualViewport.addEventListener('resize', setSizeToVisualViewport);
        setSizeToVisualViewport();
      }

      /* do any cleanup */
      return () => {
        visualViewport.removeEventListener('resize', setSizeToVisualViewport);
      };
    }
    return () => undefined;
  }, [containerRef, isKeyboardOpen, isVirtualKeyboardOpen]);
  return /*#__PURE__*/React__default.createElement(PreventScroll, null, /*#__PURE__*/React__default.createElement(Shroud, {
    $transitionState: transitionState
  }, /*#__PURE__*/React__default.createElement(View, _extends({}, rest, {
    role: "presentation",
    $fadeDuration: fadeDuration,
    $fadeState: transitionState,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: containerRef
  }), /*#__PURE__*/React__default.createElement(InlinePortalProvider, null, /*#__PURE__*/React__default.createElement(Header, null, /*#__PURE__*/React__default.createElement(CloseButton, _extends({
    tabIndex: 0,
    onClick: onClose,
    ref: closeButtonRef,
    type: "button"
  }, getCloseButtonDataTaktAttributes({
    taktValue: closeButtonProps === null || closeButtonProps === void 0 ? void 0 : closeButtonProps.taktValue
  }), closeButtonProps), /*#__PURE__*/React__default.createElement(CloseButtonIcon, {
    type: angleInlineStart
  }), closeButtonLabel)), /*#__PURE__*/React__default.createElement(Content, {
    padding: padding
  }, children)))));
};
Overlay.defaultProps = {
  closeButtonProps: undefined,
  onClose: undefined,
  closeButtonLabel: undefined
};

export { Overlay as O };
//# sourceMappingURL=Overlay-pGY68x6X.js.map
